module.exports = __webpack_public_path__ + "static/media/DEMInactive.957b5c3c.png";